import { getCustomerMainPerson } from './customerDetails';
const getPersonMainTaxDetails = (taxDetails) => taxDetails === null || taxDetails === void 0 ? void 0 : taxDetails.find((taxDetail) => taxDetail.precedence === 0);
export const getTaxDetailsFromPerson = (person) => getPersonMainTaxDetails(person === null || person === void 0 ? void 0 : person.taxDetails);
export const getUpdatedTaxDetails = (newMainTaxValues, person) => {
    var _a;
    if (!person)
        return [newMainTaxValues];
    if (((_a = person === null || person === void 0 ? void 0 : person.taxDetails) === null || _a === void 0 ? void 0 : _a.length) < 2)
        return [newMainTaxValues];
    return person === null || person === void 0 ? void 0 : person.taxDetails.map((taxDetail) => {
        if (taxDetail.precedence === 0)
            return newMainTaxValues;
        return taxDetail;
    });
};
const GERMAN_TAX_NUMBER_LENGTH = 11;
export const formatGermanTaxNumber = (tax) => tax.length === GERMAN_TAX_NUMBER_LENGTH
    ? tax.replace(/^(\d{2})(\d{3})(\d{3})(\d{3}).*/, '$1 $2 $3 $4')
    : tax;
export const getCustomerMainTaxDetails = (customer) => customer ? getTaxDetailsFromPerson(getCustomerMainPerson(customer)) : {};
//# sourceMappingURL=customerTax.js.map